<template>
  <v-dialog v-model="dialog" :persistent="direcoryChangeLoading" max-width="400">
    <template v-slot:activator="{ props }">
      <v-btn variant="outlined" size="small" v-bind="props" class="mx-3">
        {{ $t("text.change_org") }}
      </v-btn>
    </template>
    <v-card>

      <template v-if="!directoryOptionsLoading && !direcoryChangeLoading">
        <v-text-field v-model="searchword" :placeholder="$t('text.search')" prepend-inner-icon="mdi-magnify" variant="outlined"
          density="compact" class="pa-3" hide-details>
        </v-text-field>
        <v-list density="compact" class="py-0 directory-switcher-list">
          <template v-for="(option, idx) in filteredItems" :key="option.Id">
            <v-divider v-if="idx > 0" />
            <v-list-item :title="option.Name" :subtitle="orgNumberLabel(option)" lines="two"
              :active="option.Id == directory.Id" color="primary" @click="changeDirectory(option)">
              <template #prepend>
                <v-icon :icon="option.Id == directory.Id ? 'mdi-check' : 'mdi-domain'"
                  :color="option.Id == directory.Id ? 'primary' : undefined" />
              </template>
            </v-list-item>
          </template>
        </v-list>
      </template>

      <template v-else>
        <v-row no-gutters align="center" justify="center" style="height: 200px;">
          <v-progress-circular indeterminate size="100" width="4" color="primary">
          </v-progress-circular>
        </v-row>
      </template>
    </v-card>
  </v-dialog>
</template>


<script>
import client from "@/api/client";
import AuthStoreMixin from "@/helpers/mixins/AuthStoreMixin";

export default {
  name: "DirectorySwitcher",
  props: {},
  mixins: [AuthStoreMixin],
  components: {},

  data() {
    return {
      searchword: "",
      directoryOptionsLoading: false,
      direcoryChangeLoading: false,
      menuWidth: "100vw",
      dialog: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.getMenuWidth();
    }, 600);
  },

  methods: {
    orgNumberLabel(option) {
      const n = option?.OrganisationNumber;
      if (n == null || n === "") return "";
      return String(n);
    },

    changeDirectory(e) {
      //console.log(e);
      if (e.Id != this.directory.Id) {
        this.direcoryChangeLoading = true;
        client()
          .post("/api2/Token/impersonate?customerId=" + e.Id)
          .then((response) => {
            //console.log(response);
            this.updateAuthToken(response.data);
            var exceptions = [
              "CustomerMachineList",
              "Dashboard",
              "CustomerJobs",
              "Organization",
            ];
            if (!exceptions.includes(this.$route.name)) {
              this.$router.push({ name: "Dashboard" });
            }

            location.reload();
          })
          .catch((e) => {
            this.direcoryChangeLoading = false;
            console.error(e)
          });
      }
    },

    getMenuWidth() {
      var maxwidth = "100vw";
      var ref = this.$refs.directorydropdownbtn;
      if (ref) {
        var left = ref.__vue__.$el.getBoundingClientRect().x;
        var leftWithScrollbarOffset = left + 16;
        maxwidth = "calc(100vw - " + leftWithScrollbarOffset + "px)";
      }
      this.menuWidth = maxwidth;
      //console.log(this.$refs, ref, maxwidth, leftWithScrollbarOffset);
    },
  },

  computed: {
    directory() {
      return this.authCustomer;
    },

    filteredItems() {
      if (this.searchword) {
        return this.items.filter((x) =>
          x.Name.toLowerCase().includes(this.searchword.toLowerCase())
        );
      } else {
        return this.items;
      }
    },

    items() {
      if (this.authImpersonationOptions.length) {
        var list = this.authImpersonationOptions;
        var current = this.authCustomer;
        if (!list.find((x) => x.Id == current.Id)) {
          return [...list, this.authCustomer];
        } else {
          return list;
        }
      } else {
        return this.authCustomer ? [this.authCustomer] : [];
      }
    },
  },

  watch: {},
};
</script>

<style scoped>
.directory-switcher-list {
  max-height: 350px;
  overflow-y: auto;
}
</style>